import plainAdminTemplate from "@/ui/templates/plain-admin/template.config";

// WHITE-LABEL: TEMPLATE SELECTION
// A client clone can select another registered Tailwind template at build time.
const templates = Object.freeze({
  [plainAdminTemplate.id]: plainAdminTemplate,
});

const requestedTemplate = process.env.VUE_APP_UI_TEMPLATE || plainAdminTemplate.id;
const activeTemplate = templates[requestedTemplate];

if (!activeTemplate) {
  throw new Error(`Unknown UI template: ${requestedTemplate}`);
}

export { templates };
export default activeTemplate;
